import { render, staticRenderFns } from "./ReasonPrompt.vue?vue&type=template&id=17bbbcc1&"
import script from "./ReasonPrompt.vue?vue&type=script&lang=ts&"
export * from "./ReasonPrompt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports